import { useState } from "react";
import { icoonBronnen, koppelLetter } from "@/lib/koppelstatus";

/**
 * W1d: het icoon van een koppeling. Eerst het icoon van de server zelf (W1c bewaart
 * alleen een https-adres op zijn eigen domein of een kleine data:image), dan de favicon
 * van zijn eigen host en (W1d2) van het domein erboven, en als niets laadt een nette letter. Laadt een bron
 * niet, dan schuift hij door naar de volgende; er blijft nooit een kapot plaatje staan.
 */
export default function KoppelIcoon({ server, className = "h-8 w-8" }) {
  const bronnen = icoonBronnen(server);
  const [stap, setStap] = useState(0);
  const bron = bronnen[stap];
  if (!bron) {
    return (
      <span className={`${className} shrink-0 rounded-md bg-muted flex items-center justify-center text-sm font-medium`}
            aria-hidden="true" data-testid="koppel-letter">
        {koppelLetter(server?.naam)}
      </span>
    );
  }
  return (
    <img key={bron} src={bron} alt="" aria-hidden="true" referrerPolicy="no-referrer"
         className={`${className} shrink-0 rounded-md object-contain`}
         onError={() => setStap((s) => s + 1)} data-testid="koppel-icoon" />
  );
}
